import React, { useEffect, useState } from 'react';
import TableComponent from 'component/table_component/antTable/table';
import EmailTemplateModal from 'component/modal_components/email_template';
import { Tooltip } from 'antd';
import { ReactComponent as EditIcon } from 'assets/images/SVG/icons/edit-icon.svg';
import { SpanButton } from 'component/button_components/button.style';
import { getDomainSettingsMailTemplate, updateDomainSettingMailTemplate } from 'redux/slices/mailTemplateSlice';
import { useDispatch, useSelector } from 'react-redux';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { InputPatternRule } from 'utils/input_pattern';

export default function DomainEmailTemplate({ ...record }) {
  const [open, setOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const dispatch = useDispatch();
  const { domainMailTemplateData, domainMailTemplateLoading } = useSelector((state) => state.mailTemplate);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [notifyUser, setNotifyUser] = useState(false);
  const [notifyDays, setNotifyDays] = useState('');
  const [patternError, setPatternError] = useState('');
  const [apiLoading, setApiLoading] = useState(false);

  const handleSubjectChange = (data) => {
    setSubject(data);
    setPatternError(InputPatternRule.pattern.test(data) ? '' : InputPatternRule.message);
  };

  const handleMessageChange = (data) => {
    setMessage(data);
  };
  const handleOnClose = () => {
    setSelectedRowData(null);
    setNotifyDays('');
    setNotifyUser(false);
    setOpen(false);
    setPatternError('');
  };

  const handleSubmit = async () => {
    const data = {
      templateName: selectedRowData.templateName,
      subject: subject,
      message: message,
      Id: selectedRowData.id,
      ...((selectedRowData.tempId === 9 || selectedRowData.tempId === 10) && {
        [selectedRowData.tempId === 10 ? 'notifyBefore' : 'notifyAfter']: notifyDays,
        [selectedRowData.tempId === 10 ? 'expiryNotify' : 'expiredNotify']: notifyUser,
      }),
    };
    try {
      setApiLoading(true);
      const response = await dispatch(updateDomainSettingMailTemplate(data));
      if (response.payload && response.payload.status === 200) {
        SweetSweetAlert({ sweetData: response.payload.data, icon: 'success', buttonColor: 'green' });
      } else {
        SweetSweetAlert({ text: response.payload.data, icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setApiLoading(false);
    }
    await dispatch(getDomainSettingsMailTemplate(record.id));
    await handleOnClose();
  };

  useEffect(() => {
    dispatch(getDomainSettingsMailTemplate(record.id));
  }, [dispatch]);
  const columns = [
    {
      title: 'Sl.No',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Template Name',
      dataIndex: 'templateName',
    },
    {
      title: 'Subject',
      dataIndex: 'subject',
    },
    {
      title: 'Actions',
      dataIndex: 'action',
      render: (_, record) => (
        <Tooltip
          className='af-superadmin-domain-mail-template-tooltip domain-settings-mail-template-tooltip'
          title='Update'
          color='#597081'
        >
          <SpanButton
            className='af-superadmin-domain-mail-template-tooltip-button domain-settings-mail-template-tooltip-button'
            onClick={() => handleEditClick(record)}
          >
            <EditIcon className='af-superadmin-domain-mail-template-tooltip-icon domain-settings-mail-template-tooltip-icon' />
          </SpanButton>
        </Tooltip>
      ),
    },
  ];

  const handleEditClick = (record) => {
    setSelectedRowData(record);
    setSubject(record.subject);
    setPatternError(InputPatternRule.pattern.test(record.subject) ? '' : InputPatternRule.message);
    setMessage(record.message);
    setOpen(true);
    if (record.tempId === 10) {
      setNotifyDays(record.notifyBefore);
      setNotifyUser(record.expiryNotify);
    } else if (record.tempId === 9) {
      setNotifyDays(record.notifyAfter);
      setNotifyUser(record.expiredNotify);
    } else {
      setNotifyDays('');
      setNotifyUser(false);
    }
  };
  return (
    <div>
      <div className='af-superadmin--domain-mail-template-table-wrap domain-settings-mail-template-table-wrap'>
        {domainMailTemplateLoading ? (
          <ModalOpenLoader />
        ) : (
          <TableComponent
            className='modal-table'
            columns={columns}
            key={domainMailTemplateData && domainMailTemplateData.tempId}
            data={domainMailTemplateData && domainMailTemplateData}
          />
        )}
      </div>

      {open && (
        <EmailTemplateModal
          className='af-superadmin--domain-mail-template-modal domain-settings-mail-template-modal'
          visible={open}
          onClose={() => {
            setSelectedRowData(null);
            setOpen(false);
          }}
          selectedRowData={selectedRowData}
          id={selectedRowData.tempId}
          apiLoading={apiLoading}
          handleSubjectChange={handleSubjectChange}
          handleMessageChange={handleMessageChange}
          handleSubmit={handleSubmit}
          subject={subject}
          message={message}
          setSubject={setSubject}
          setMessage={setMessage}
          patternError={patternError}
          notifyDays={notifyDays}
          notifyUser={notifyUser}
          setNotifyDays={setNotifyDays}
          setNotifyUser={setNotifyUser}
        />
      )}
    </div>
  );
}
